import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2, LogIn } from "lucide-react";
import { LOGO_URL } from "@/data/content";
import { Reveal, GoldLine } from "@/components/Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
      navigate(data.role === "partner" ? "/area-riservata" : "/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Accesso non riuscito. Riprova.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main data-testid="admin-login-page" className="bg-[#080808] min-h-screen flex items-center justify-center px-6">
      <div className="w-full max-w-md py-32">
        <Reveal>
          <img src={LOGO_URL} alt="Billions Group" className="h-16 w-auto mx-auto mb-10" />
        </Reveal>
        <Reveal delay={0.1}>
          <h1 className="font-display text-3xl sm:text-4xl font-light text-[#F5F2EB] text-center tracking-tight">
            Dashboard <span className="gold-gradient-text italic">Admin</span>
          </h1>
        </Reveal>
        <GoldLine className="mt-6 w-20 mx-auto" />
        <Reveal delay={0.2}>
          <form
            onSubmit={submit}
            data-testid="admin-login-form"
            className="mt-10 bg-[#141414] border border-[#C6A45D]/20 p-8 sm:p-10 space-y-6"
          >
            {error && (
              <div data-testid="admin-login-error" className="border border-red-900/50 bg-[#1D1D1D] px-4 py-3 text-sm text-red-300">
                {error}
              </div>
            )}
            <div>
              <label htmlFor="admin-email" className="block eyebrow mb-3 !text-[10px]">Email</label>
              <input
                id="admin-email"
                data-testid="admin-login-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@billionsgroup.it"
                className="w-full bg-[#1D1D1D] border border-[#A5A5A5]/25 text-[#F5F2EB] placeholder-[#A5A5A5]/50 px-5 py-4 text-sm font-light focus:outline-none focus:border-[#E5C776] focus:ring-1 focus:ring-[#E5C776] transition-colors duration-300"
              />
            </div>
            <div>
              <label htmlFor="admin-password" className="block eyebrow mb-3 !text-[10px]">Password</label>
              <input
                id="admin-password"
                data-testid="admin-login-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••••"
                className="w-full bg-[#1D1D1D] border border-[#A5A5A5]/25 text-[#F5F2EB] placeholder-[#A5A5A5]/50 px-5 py-4 text-sm font-light focus:outline-none focus:border-[#E5C776] focus:ring-1 focus:ring-[#E5C776] transition-colors duration-300"
              />
            </div>
            <button
              type="submit"
              data-testid="admin-login-submit"
              disabled={loading}
              className="w-full inline-flex items-center justify-center gap-3 px-8 py-4 bg-[#C6A45D] text-[#080808] text-xs tracking-[0.25em] uppercase font-semibold hover:bg-[#E5C776] disabled:opacity-60 transition-colors duration-300"
            >
              {loading ? <Loader2 size={15} className="animate-spin" /> : <LogIn size={15} />}
              Accedi
            </button>
          </form>
        </Reveal>
      </div>
    </main>
  );
}
